import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d51e33f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-card" }
const _hoisted_2 = { class: "custom-card-title title-card foldable-section-title" }
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "foldable-section-title-content" }
const _hoisted_5 = {
  key: 0,
  class: "foldable-section-count"
}
const _hoisted_6 = {
  key: 0,
  class: "foldable-section-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createElementVNode("button", {
        class: "foldable-section-toggle",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSectionOpen = !_ctx.isSectionOpen)),
        "aria-expanded": _ctx.isSectionOpen
      }, [
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
          (_ctx.shouldShowCount)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (" + _toDisplayString(_ctx.count) + ") ", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["icon is-small foldable-section-icon", { 'is-open': _ctx.isSectionOpen }]),
          "aria-hidden": "true"
        }, [
          _createVNode(_component_fa_icon, { icon: "chevron-down" })
        ], 2)
      ], 8, _hoisted_3)
    ]),
    _createVNode(_Transition, { name: "foldable-section" }, {
      default: _withCtx(() => [
        (_ctx.isSectionOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}